import React from 'react'

export default function CustomNoteImage(props) {
  const { data } = props

  return (
    <div>
      {data.details && (
        <>
          {data.title && (
            <p style={{ marginTop: 10, marginBottom: 5 }}>
              <b>{data.title}</b>
            </p>
          )}
          {data.details.map((item, index) => {
            return (
              <div key={'image-' + index} style={{ width: '100%' /*textAlign: 'center'*/ }}>
                <img style={{ height: '250px' }} src={item} />
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
